import axios from 'axios';
import config from './app.config';

// Crear instancia de axios con configuración base
const apiClient = axios.create({
  baseURL: config.api.baseURL,
  timeout: 30000, // 30 segundos
  headers: {
    'Content-Type': 'application/json',
  },
});

// Variable para almacenar la función de obtener token
let getAuthTokenFn = null;

// Función para configurar el método de obtener token
export const setAuthTokenProvider = (tokenProvider) => {
  getAuthTokenFn = tokenProvider;
};

// Interceptor de REQUEST - Añadir token automáticamente
apiClient.interceptors.request.use(
  (config) => {
    try {
      // Si la URL es absoluta, no usar baseURL
      if (config.url && (config.url.startsWith('http://') || config.url.startsWith('https://'))) {
        config.baseURL = '';
      }

      // Obtener token si la función está configurada
      if (getAuthTokenFn && typeof getAuthTokenFn === 'function') {
        const token = getAuthTokenFn();
        console.log('🔍 Debug token:', {
          tokenFunction: !!getAuthTokenFn,
          tokenValue: token,
          tokenType: typeof token,
          tokenLength: token ? token.length : 0
        });
        
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
          console.log('🔐 Token añadido automáticamente a request:', config.url);
        } else {
          console.log('⚠️ Token es null/undefined para request:', config.url);
          console.log('🔍 getAuthTokenFn type:', typeof getAuthTokenFn);
        }
      } else {
        console.log('⚠️ getAuthTokenFn no está configurado');
      }
    } catch (error) {
      console.error('❌ Error al configurar request:', error);
    }
    
    return config;
  },
  (error) => {
    console.error('❌ Error en interceptor de request:', error);
    return Promise.reject(error);
  }
);

// Interceptor de RESPONSE - Manejar errores de autenticación
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      const { status } = error.response;
      
      // Manejar errores de autenticación
      if (status === 401) {
        console.error('🔒 Error 401: Token inválido o expirado');
        // Aquí podrías redirigir al login si es necesario
        // window.location.href = '/login';
      } else if (status === 403) {
        console.error('🚫 Error 403: Acceso denegado');
      } else if (status >= 500) {
        console.error('🔥 Error del servidor:', status, error.response.data);
      }
    } else if (error.request) {
      console.error('📡 Error de red - no se recibió respuesta:', error.message);
    } else {
      console.error('❌ Error desconocido:', error.message);
    }
    
    return Promise.reject(error);
  }
);

// Función helper para requests con multipart/form-data
export const apiClientMultipart = axios.create({
  baseURL: config.api.baseURL,
  timeout: 60000, // 60 segundos para uploads
});

// Configurar interceptors para multipart también
apiClientMultipart.interceptors.request.use(
  (config) => {
    try {
      // Si la URL es absoluta, no usar baseURL
      if (config.url && (config.url.startsWith('http://') || config.url.startsWith('https://'))) {
        config.baseURL = '';
      }

      if (getAuthTokenFn && typeof getAuthTokenFn === 'function') {
        const token = getAuthTokenFn();
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
          console.log('🔐 Token añadido a multipart request:', config.url);
        }
      }
    } catch (error) {
      console.error('❌ Error al configurar multipart request:', error);
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

apiClientMultipart.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('❌ Error en multipart request:', error.response?.status, error.message);
    return Promise.reject(error);
  }
);

export default apiClient; 